import React, { Component } from 'react'
import { Card, CardBody, CardHeader } from "reactstrap"
import { getCommitTimesStatisticsV2 } from "../../services/api/apiNextBox"
import changeNumberFormat from "../helpers/changeNumberFormat"
import TableNoItem from "./data/TableNoItem"
import TableHeader from "./data/TableHeader"
import TableError from "./data/TableError"
import TableRowStatistic from "./data/TableRowStatistic"
import { Select, Checkbox, Spin } from 'antd'
import moment from 'moment'

const EXCLUDED_NOTE_TAGS = 'hold-ship,waiting-update-design'

class OvertimedStatisticsV2 extends Component {
    state = {
        data: [],
        partner: '',
        filters: '',
        error: '',
        loading: false,
        embroideryFilter: false,
        silkFilter: false,
        noteTagFilter: 'exclude',
    }

    componentDidMount() {
        this._getData()
    }

    _getData = async () => {
        this.setState({
            loading: true,
            error: ''
        })
        const lastYear = moment().subtract(365, 'days').format('DD/MM/YYYY')

        try {
            const {
                partner,
                filters,
                noteTagFilter
            } = this.state
            const { success, data, message } = await getCommitTimesStatisticsV2({
                partner,
                ...filters,
                created_from: lastYear,
                exclude_note_tags: noteTagFilter === 'exclude' ? EXCLUDED_NOTE_TAGS : '',
            })

            if (!success) {
                return this.setState({
                    error: message,
                    loading: false
                })
            }

            const newData = data.map(itemData => {
                const {
                    overtime_without_note_1_day,
                    overtime_without_note_1_half_day,
                    overtime_without_note_2_day,
                    overtime_without_note_2_half_day,
                    overtime_without_note_3_day,
                    overtime_without_note_4_day,
                    overtime_without_note_5_day,
                    overtime_without_note_6_day,
                    overtime_with_note_1_day,
                    overtime_with_note_2_day,
                    overtime_with_note_3_day,
                    overtime_with_note_4_day,
                    overtime_with_note_5_day,
                    overtime_with_note_6_day,
                    remaining_time_1_day,
                    remaining_time_2_day,
                    remaining_time_3_day,
                    remaining_time_4_day,
                    remaining_time_5_day,
                    remaining_time_6_day
                } = itemData
                const overtime_with_note_total = overtime_with_note_1_day + overtime_with_note_2_day + overtime_with_note_3_day + overtime_with_note_4_day + overtime_with_note_5_day + overtime_with_note_6_day
                const overtime_without_note_total = overtime_without_note_1_day + overtime_without_note_1_half_day + overtime_without_note_2_day + overtime_without_note_2_half_day + overtime_without_note_3_day + overtime_without_note_4_day + overtime_without_note_5_day + overtime_without_note_6_day
                const remaining_total = remaining_time_1_day + remaining_time_2_day + remaining_time_3_day + remaining_time_4_day + remaining_time_5_day + remaining_time_6_day

                return {
                    ...itemData,
                    overtime_with_note_total,
                    overtime_without_note_total,
                    remaining_total
                }
            })

            newData.sort((a, b) => {
                return b.overtime_without_note_total - a.overtime_without_note_total
            })

            this.setState({
                data: newData,
                loading: false
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _calculatorTotalArray = (arrTotal, key) => {
        return arrTotal.reduce((accumulator, currentValue) => accumulator + (currentValue[key] || 0), 0)
    }

    _reloadData = () => {
        return this._getData()
    }

    _handleChangePartner = (value) => {
        const [p, v] = `${value}`.split(':')
        const prop = p && v ? p : 'partner'
        const val = p && v ? v : value

        this.setState({
            ...(
                p && v
                    ? {
                        filters: {
                            [prop]: val
                        },
                        partner: ''
                    }
                    : {
                        [prop]: val,
                        filters: ''
                    }
            )
        }, () => {
            this._reloadData()
        })
    }

    _handleFilterCheckbox = (checked, field) => {
        this.setState({
            [field]: checked
        })
    }

    _handleChangeNoteTagFilter = (value) => {
        this.setState({
            noteTagFilter: value
        }, () => {
            this._reloadData()
        })
    }

    render() {
        const { data, error, loading, partner, filters = {}, embroideryFilter, silkFilter, noteTagFilter } = this.state
        const selectedValue = filters ? [Object.keys(filters)[0], Object.values(filters)[0]].join(':') : partner
        let fixedQuery = [
            partner && `partner=${partner}`,
        ]

        // cùi bắp!!!
        if (filters) {
            const prop = Object.keys(filters)[0]
            const value = ['is_cheap_product'].includes(prop) ? Object.values(filters)[0] : Object.values(filters)[0].toUpperCase()

            if (prop !== 'order_type') {
                fixedQuery.push(`${prop}=${value}`)
            } else {
                const map = {
                    'FBA': 'is_fba',
                    'TIKTOK': 'is_tiktok'
                }

                if (map[value]) {
                    fixedQuery.push(`${map[value]}=y`)
                } else {
                    fixedQuery.push(...Object.values(map).map(prop => `${prop}=n`))
                }
            }
        }

        fixedQuery = fixedQuery.filter(Boolean).join('&')
        fixedQuery = fixedQuery.length ? `&${fixedQuery}` : ''

        // "Ngoại trừ" (is_hold_ship/exclude_tags) chỉ có ý nghĩa với cột "quá hạn do note"
        // (hasNote=y) — không được gắn vào link "quá hạn không note" (hasNote=n) hay
        // "còn lại" (remaining_time), nếu không sẽ ẩn nhầm đơn ở 2 cột đó.
        let fixedQueryWithNote = [
            // Trang /admin đã có sẵn filter "Hold ship" (is_hold_ship=n), tận dụng lại thay vì tự lọc tag.
            noteTagFilter === 'exclude' && 'is_hold_ship=n',
            // "Request update" ở /admin chỉ có option loại trừ rộng (no-request, gồm cả waiting-update-address/updated),
            // không khớp phạm vi hẹp "chỉ Request design" nên vẫn cần tự lọc riêng tag này.
            noteTagFilter === 'exclude' && 'exclude_tags=waiting-update-design',
        ]
        fixedQueryWithNote = fixedQueryWithNote.filter(Boolean).join('&')
        fixedQueryWithNote = fixedQuery + (fixedQueryWithNote.length ? `&${fixedQueryWithNote}` : '')

        const filteredData = data.filter(item => {
            const categories = item.categories || []

            // Không check gì → lấy hết
            if (!embroideryFilter && !silkFilter) return true

            // Chỉ check SP Thêu
            if (embroideryFilter && !silkFilter) {
                return categories.includes('embroidery')
            }

            // Chỉ check Hàng lụa
            if (!embroideryFilter && silkFilter) {
                return categories.includes('silk') || categories.includes('pyjama')
            }

            // Check cả 2 → có 1 trong 2 là được
            if (embroideryFilter && silkFilter) {
                return categories.includes('embroidery') || categories.includes('silk') || categories.includes('pyjama')
            }

            return true
        })

        let queryProductsType = []
        if (embroideryFilter || silkFilter) {
            filteredData.forEach(item => {
                if (item && item.type) {
                    queryProductsType.push(`products.type=${item.type}`)
                }
            })
        }

        queryProductsType = queryProductsType.filter(Boolean).join('&')
        queryProductsType = queryProductsType.length ? `&${queryProductsType}` : ''

        const totalRemainingTime4Day = this._calculatorTotalArray(filteredData, 'remaining_time_4_day') + this._calculatorTotalArray(filteredData, 'remaining_time_5_day') + this._calculatorTotalArray(filteredData, 'remaining_time_6_day')

        return (
            <div className="PackingStatistics">
                <Card>
                    <CardHeader className="bg-warning text-white header-elements-inline">
                        <h2 className="card-title"><i className="icon-calendar" /> Thời gian sắp/đã quá hạn</h2>
                        <div className='d-flex'>
                            <div className="FilterVip d-flex align-items-center pr-2 mr-2 border-right FilterPartner">
                                <Checkbox
                                    checked={embroideryFilter}
                                    onChange={e => this._handleFilterCheckbox(e.target.checked, 'embroideryFilter')}
                                    disabled={loading}
                                >
                                    SP Thêu
                                </Checkbox>
                            </div>
                            <div className="FilterVip d-flex align-items-center pr-2 mr-2 border-right FilterPartner">
                                <Checkbox
                                    checked={silkFilter}
                                    onChange={e => this._handleFilterCheckbox(e.target.checked, 'silkFilter')}
                                    disabled={loading}
                                >
                                    Hàng lụa
                                </Checkbox>
                            </div>
                            <div className='filterPartner'>
                                <Select
                                    style={{ width: 120 }}
                                    onChange={this._handleChangePartner}
                                    options={[
                                        { value: '', label: 'All' },
                                        // { value: 'BINHMINH', label: 'Bình Minh' },
                                        // { value: 'QUANGMINH', label: 'Quang Minh' },
                                        // { value: 'TOANCAU', label: 'Toàn Cầu' },
                                        { value: 'VIP', label: 'VIP' },
                                        { value: 'NOTVIP', label: 'NOT VIP' },
                                        { value: 'order_type:TikTok', label: 'TikTok' },
                                        { value: 'is_cheap_product:true', label: 'SP giá rẻ' },
                                    ]}
                                    value={selectedValue || ''}
                                />
                            </div>
                        </div>
                    </CardHeader>

                    <CardBody>
                        <Spin spinning={loading} tip="Đang tải...">
                        <div className="wrapTable StatiticOvetime">
                            <table className="table">
                                <TableHeader
                                    noteTagFilter={noteTagFilter}
                                    onChangeNoteTagFilter={this._handleChangeNoteTagFilter}
                                    loading={loading}
                                />
                                <tbody>
                                    {
                                        error !== '' && <TableError error={error} />
                                    }

                                    {
                                        (filteredData.length === 0 && error === '' && !loading) && <TableNoItem />
                                    }

                                    {
                                        (filteredData.length > 0) && (
                                            <tr className="totalColumns text-right">
                                                <td className="borderRight" />
                                                {/* <TableRowStatistic
                                                type='' level='level1'
                                                query='?products.remaining_time[from]=5'
                                                value={
                                                    this._calculatorTotalArray(filteredData, 'remaining_time_6_day') > 0
                                                        ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'remaining_time_6_day'))
                                                        : '-'
                                                }
                                            /> */}
                                                {/* <TableRowStatistic
                                                type='' level='level1'
                                                query='?products.remaining_time[from]=4&products.remaining_time[to]=5'
                                                value={
                                                    this._calculatorTotalArray(filteredData, 'remaining_time_5_day') > 0
                                                        ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'remaining_time_5_day'))
                                                        : '-'
                                                }
                                            /> */}
                                                <TableRowStatistic
                                                    type='' level='level1'
                                                    query={`?products.remaining_time[from]=3${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        totalRemainingTime4Day > 0
                                                            ? changeNumberFormat(totalRemainingTime4Day)
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level2'
                                                    query={`?products.remaining_time[from]=2&products.remaining_time[to]=3${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'remaining_time_3_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'remaining_time_3_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level3'
                                                    query={`?products.remaining_time[from]=1&products.remaining_time[to]=2${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'remaining_time_2_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'remaining_time_2_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level4'
                                                    query={`?products.remaining_time[from]=0&products.remaining_time[to]=1${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'remaining_time_1_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'remaining_time_1_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level5' typeRow='colTotal borderRight'
                                                    query={`?products.remaining_time[from]=0${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'remaining_total') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'remaining_total'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level11'
                                                    query={`?products.overtimeGt=0&products.overtimeLte=1&hasNote=y${fixedQueryWithNote}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_with_note_1_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_with_note_1_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level12'
                                                    query={`?products.overtimeGt=1&products.overtimeLte=2&hasNote=y${fixedQueryWithNote}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_with_note_2_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_with_note_2_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level13'
                                                    query={`?products.overtimeGt=2&products.overtimeLte=3&hasNote=y${fixedQueryWithNote}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_with_note_3_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_with_note_3_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level14'
                                                    query={`?products.overtimeGt=3&products.overtimeLte=4&hasNote=y${fixedQueryWithNote}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_with_note_4_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_with_note_4_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level15'
                                                    query={`?products.overtimeGt=4&products.overtimeLte=5&hasNote=y${fixedQueryWithNote}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_with_note_5_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_with_note_5_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level15'
                                                    query={`?products.overtimeGt=5&hasNote=y${fixedQueryWithNote}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_with_note_6_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_with_note_6_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level15' typeRow='colTotal borderRight'
                                                    query={`?products.overtime=y&hasNote=y${fixedQueryWithNote}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_with_note_total') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_with_note_total'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level6'
                                                    query={`?products.overtimeGt=0&products.overtimeLte=1&hasNote=n${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_without_note_1_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_without_note_1_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level6'
                                                    query={`?products.overtimeGt=1&products.overtimeLte=1.5&hasNote=n${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_without_note_1_half_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_without_note_1_half_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level7'
                                                    query={`?products.overtimeGt=1.5&products.overtimeLte=2&hasNote=n${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_without_note_2_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_without_note_2_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level7'
                                                    query={`?products.overtimeGt=2&products.overtimeLte=2.5&hasNote=n${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_without_note_2_half_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_without_note_2_half_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level8'
                                                    query={`?products.overtimeGt=2.5&products.overtimeLte=3&hasNote=n${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_without_note_3_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_without_note_3_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level9'
                                                    query={`?products.overtimeGt=3&products.overtimeLte=4&hasNote=n${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_without_note_4_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_without_note_4_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level9'
                                                    query={`?products.overtimeGt=4&products.overtimeLte=5&hasNote=n${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_without_note_5_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_without_note_5_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level9'
                                                    query={`?products.overtimeGt=5&hasNote=n${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_without_note_6_day') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_without_note_6_day'))
                                                            : '-'
                                                    }
                                                />
                                                <TableRowStatistic
                                                    type='' level='level10'
                                                    query={`?products.overtime=y&hasNote=n${fixedQuery}${queryProductsType}`}
                                                    value={
                                                        this._calculatorTotalArray(filteredData, 'overtime_without_note_total') > 0
                                                            ? changeNumberFormat(this._calculatorTotalArray(filteredData, 'overtime_without_note_total'))
                                                            : '-'
                                                    }
                                                />
                                            </tr>
                                        )
                                    }

                                    {
                                        (filteredData.length > 0) && (
                                            filteredData.map((item, index) => {
                                                const totalRemaining = item.remaining_time_1_day + item.remaining_time_2_day + item.remaining_time_3_day + item.remaining_time_4_day + item.remaining_time_5_day + item.remaining_time_6_day
                                                const totalOverTimeWithNote = item.overtime_with_note_1_day + item.overtime_with_note_2_day + item.overtime_with_note_3_day + item.overtime_with_note_4_day + item.overtime_with_note_5_day + item.overtime_with_note_6_day
                                                const totalOverTimeWithoutNote = item.overtime_without_note_1_day + item.overtime_without_note_1_half_day + item.overtime_without_note_2_day + item.overtime_without_note_2_half_day + item.overtime_without_note_3_day + item.overtime_without_note_4_day + item.overtime_without_note_5_day + item.overtime_without_note_6_day

                                                return (
                                                    <tr key={index} className='text-right'>
                                                        <TableRowStatistic
                                                            type='none' level='colType borderRight'
                                                            query={`?products.type=${item.type}&products.overtime=y${fixedQuery}`}
                                                            value={item.type}
                                                        />
                                                        {/* <TableRowStatistic
                                                        type='none' level='level1'
                                                        query={`?products.type=${item.type}&products.remaining_time[from]=5`}
                                                        value={item.remaining_time_6_day > 0 ? changeNumberFormat(item.remaining_time_6_day) : '-'}
                                                    /> */}
                                                        {/* <TableRowStatistic
                                                        type='none' level='level1'
                                                        query={`?products.type=${item.type}&products.remaining_time[from]=4&products.remaining_time[to]=5`}
                                                        value={item.remaining_time_5_day > 0 ? changeNumberFormat(item.remaining_time_5_day) : '-'}
                                                    /> */}
                                                        <TableRowStatistic
                                                            type='none' level='level1'
                                                            query={`?products.type=${item.type}&products.remaining_time[from]=3${fixedQuery}`}
                                                            value={item.remaining_time_4_day > 0 ? changeNumberFormat(item.remaining_time_4_day + item.remaining_time_5_day + item.remaining_time_6_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level2'
                                                            query={`?products.type=${item.type}&products.remaining_time[from]=2&products.remaining_time[to]=3${fixedQuery}`}
                                                            value={item.remaining_time_3_day > 0 ? changeNumberFormat(item.remaining_time_3_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level3'
                                                            query={`?products.type=${item.type}&products.remaining_time[from]=1&products.remaining_time[to]=2${fixedQuery}`}
                                                            value={item.remaining_time_2_day > 0 ? changeNumberFormat(item.remaining_time_2_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level4'
                                                            query={`?products.type=${item.type}&products.remaining_time[from]=0&products.remaining_time[to]=1${fixedQuery}`}
                                                            value={item.remaining_time_1_day > 0 ? changeNumberFormat(item.remaining_time_1_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='colTotal borderRight level5'
                                                            query={`?products.type=${item.type}&products.remaining_time[from]=0${fixedQuery}`}
                                                            value={totalRemaining > 0 ? changeNumberFormat(totalRemaining) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level11'
                                                            query={`?products.type=${item.type}&products.overtimeGt=0&products.overtimeLte=1&hasNote=y${fixedQueryWithNote}`}
                                                            value={item.overtime_with_note_1_day > 0 ? changeNumberFormat(item.overtime_with_note_1_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level12'
                                                            query={`?products.type=${item.type}&products.overtimeGt=1&products.overtimeLte=2&hasNote=y${fixedQueryWithNote}`}
                                                            value={item.overtime_with_note_2_day > 0 ? changeNumberFormat(item.overtime_with_note_2_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level13'
                                                            query={`?products.type=${item.type}&products.overtimeGt=2&products.overtimeLte=3&hasNote=y${fixedQueryWithNote}`}
                                                            value={item.overtime_with_note_3_day > 0 ? changeNumberFormat(item.overtime_with_note_3_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level14'
                                                            query={`?products.type=${item.type}&products.overtimeGt=3&products.overtimeLte=4&hasNote=y${fixedQueryWithNote}`}
                                                            value={item.overtime_with_note_4_day > 0 ? changeNumberFormat(item.overtime_with_note_4_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level15'
                                                            query={`?products.type=${item.type}&products.overtimeGt=4&products.overtimeLte=5&hasNote=y${fixedQueryWithNote}`}
                                                            value={item.overtime_with_note_5_day > 0 ? changeNumberFormat(item.overtime_with_note_5_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level15'
                                                            query={`?products.type=${item.type}&products.overtimeGt=5&hasNote=y${fixedQueryWithNote}`}
                                                            value={item.overtime_with_note_6_day > 0 ? changeNumberFormat(item.overtime_with_note_6_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='colTotal borderRight level15'
                                                            query={`?products.type=${item.type}&products.overtime=y&hasNote=y${fixedQueryWithNote}`}
                                                            value={totalOverTimeWithNote > 0 ? changeNumberFormat(totalOverTimeWithNote) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level6'
                                                            query={`?products.type=${item.type}&products.overtimeGt=0&products.overtimeLte=1&hasNote=n${fixedQuery}`}
                                                            value={item.overtime_without_note_1_day > 0 ? changeNumberFormat(item.overtime_without_note_1_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level6'
                                                            query={`?products.type=${item.type}&products.overtimeGt=1&products.overtimeLte=1.5&hasNote=n${fixedQuery}`}
                                                            value={item.overtime_without_note_1_half_day > 0 ? changeNumberFormat(item.overtime_without_note_1_half_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level7'
                                                            query={`?products.type=${item.type}&products.overtimeGt=1.5&products.overtimeLte=2&hasNote=n${fixedQuery}`}
                                                            value={item.overtime_without_note_2_day > 0 ? changeNumberFormat(item.overtime_without_note_2_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level7'
                                                            query={`?products.type=${item.type}&products.overtimeGt=2&products.overtimeLte=2.5&hasNote=n${fixedQuery}`}
                                                            value={item.overtime_without_note_2_half_day > 0 ? changeNumberFormat(item.overtime_without_note_2_half_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level8'
                                                            query={`?products.type=${item.type}&products.overtimeGt=2.5&products.overtimeLte=3&hasNote=n${fixedQuery}`}
                                                            value={item.overtime_without_note_3_day > 0 ? changeNumberFormat(item.overtime_without_note_3_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level9'
                                                            query={`?products.type=${item.type}&products.overtimeGt=3&products.overtimeLte=4&hasNote=n${fixedQuery}`}
                                                            value={item.overtime_without_note_4_day > 0 ? changeNumberFormat(item.overtime_without_note_4_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level9'
                                                            query={`?products.type=${item.type}&products.overtimeGt=4&products.overtimeLte=5&hasNote=n${fixedQuery}`}
                                                            value={item.overtime_without_note_5_day > 0 ? changeNumberFormat(item.overtime_without_note_5_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='level9'
                                                            query={`?products.type=${item.type}&products.overtimeGt=5&hasNote=n${fixedQuery}`}
                                                            value={item.overtime_without_note_6_day > 0 ? changeNumberFormat(item.overtime_without_note_6_day) : '-'}
                                                        />
                                                        <TableRowStatistic
                                                            type='none' level='colTotal level10'
                                                            query={`?products.type=${item.type}&products.overtime=y&hasNote=n${fixedQuery}`}
                                                            value={totalOverTimeWithoutNote > 0 ? changeNumberFormat(totalOverTimeWithoutNote) : '-'}
                                                        />
                                                    </tr>
                                                )
                                            })
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        </Spin>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default OvertimedStatisticsV2